import { Injectable } from '@angular/core';

const MIN_TIMEOUT = 200;

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor() {
    this.hide();
  }

  show(): void {
    const loader = document.getElementById('loader');
    if (loader) {
      setTimeout(() => {
        loader.style.display = 'flex'
      }, MIN_TIMEOUT);
    }
  }

  hide(): void {
    const loader = document.getElementById('loader');
    if (loader) {
      setTimeout(() => {
        loader.style.display = 'none';
      }, MIN_TIMEOUT);
    }
  }
}
